var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7b7b85"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18m0-16.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 12.75h-3a.76.76 0 0 1-.75-.75V7a.75.75 0 1 1 1.5 0v4.25H15a.75.75 0 1 1 0 1.5"
}))));
export default SvgClock;